/**
 * @name PendingSchedule
 * @description Componente de autorización de horarios en configuración de perfil
 * @author Gerardo de León
 */

import React, { Component } from 'react';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { trackPromise } from 'react-promise-tracker';

import { Environment } from '@tycommon/config';
import { DataGrid, EmployeeDetail, LoadingWrapper } from '@tycommon/components';
import { EmployeeService, ScheduleService, NotificationsService, ResponseHandlerService } from '@tycommon/services';
import { Icons, MUI, Typography } from '@tycommon/styles';

// Components
import Validate from './components/validate';
import CommentDialog from './components/comment.dialog';

class PendingSchedule extends Component {
  constructor(props) {
    super(props);

    this.dataGridRef = React.createRef();
    this.enterpriseParams = JSON.parse(localStorage.getItem('ls.infoUsuario')).Empresa;
    this.userInfo = JSON.parse(localStorage.getItem('ls.infoUsuario')).Empleado;
    this.state = {
      employeeId: props.queryParams.get('idEmpleado') ? props.queryParams.get('idEmpleado') : this.userInfo.IdEmpleado,
      isThirdLevel: this.userInfo.NivelJerarquia === 3,
      isSupervisor: this.userInfo.NivelJerarquia >= 2,
      gridConfig: {
        rows: [],
        columns: [
          { id: 'Dia', label: i18n.t('GenericMessages.day'), visible: true, filter: null },
          { id: 'Entrada', label: i18n.t('Shedule.entryHours'), visible: true, filter: 'Time12HoursFilter' },
          { id: 'Salida', label: i18n.t('Shedule.departureTime'), visible: true, filter: 'Time12HoursFilter' },
          { id: 'Estatus', label: i18n.t('Shedule.workdays'), visible: true, filter: 'ActiveIconFilter' },
        ],
        canAdd: false,
        canEdit: false,
        canDelete: false,
        canSelect: false,
      },
      showCommentDialog: {
        action: '',
        open: false
      },
      employeeFilter: {
        id: this.userInfo.IdEmpleado,
        name: `${this.userInfo.Nombres} ${this.userInfo.Apellidos}`,
        status: '',
        photo: '',
        job: ''
      },
      structure: [],
      selectedEmployeeFromFilter: '',
      mySchedule: true,
      status: 0,
      statusName: '',
    };
  }

  componentDidMount() {
    const {
      employeeId,
      isSupervisor,
      isThirdLevel
    } = this.state;

    const {
      onChangeTab
    } = this.props;

    // Entra desde una notificación
    if (localStorage.getItem('ls.Parametros')) {
      let params = JSON.parse(localStorage.getItem('ls.Parametros'));
      localStorage.removeItem('ls.Parametros');
      onChangeTab(params.Tab ? params.Tab : 0);
      if (params.filter) {
        let selectedEmployeeFromFilter = {
          IdEmpleado: params.filter.Id,
          IdReporta: params.filter.IdReporta,
          Nombre: params.filter.Nombre
        };
        EmployeeService.getOne(params.filter.Id)
          .then((response) => {
            let employeeFilter = {
              id: response.IdEmpleado,
              name: response.Nombre,
              photo: response.Foto,
              job: response.Puesto
            };
            this.filterShedule(selectedEmployeeFromFilter);
            this.setState({ selectedEmployeeFromFilter, employeeFilter });
          })
          .catch(() => {
            ResponseHandlerService.error();
          });
      }
    }

    this.checkStatus(employeeId);
    this.getPendingShedule(employeeId);

    if (isSupervisor || isThirdLevel) {
      this.getStructure();
    }
  }

  /**
   * Consulta el horario de un empleado
   * @param {number} employeeId
   */
  getPendingShedule = (employee) => {
    if (employee) {
      trackPromise(
        ScheduleService.getSupervisor(employee)
          .then((response) => {
            const { gridConfig } = this.state;
            gridConfig.rows = response;
            this.setState((prevState) => ({
              gridConfig: { ...prevState.gridConfig, gridConfig },
            }));
          })
          .catch((error) => {
            ResponseHandlerService.error(error);
            const { gridConfig } = this.state;
            gridConfig.rows = [];
            this.setState((prevState) => ({
              gridConfig: { ...prevState.gridConfig, gridConfig },
            }));
          }),
        'loading-tab-pending-schedule');
    }
  }

  /**
   * Filtra el horario de un usuario
   * @param {object} employee
   */
  filterShedule = (employee) => {
    let mySchedule;

    if (employee) {
      mySchedule = false;
    } else {
      mySchedule = true;
    }

    this.setState({
      mySchedule,
      employeeFilter: {
        id: employee ? employee.IdEmpleado : this.userInfo.IdEmpleado,
        name: employee ? employee.Nombre : `${this.userInfo.Nombres} ${this.userInfo.Apellidos}`,
        photo: employee ? employee.Foto : '',
        job: employee ? employee.Puesto : ''
      },
      isSupervisor: employee ? employee.IdReporta === this.userInfo.IdEmpleado : this.userInfo.NivelJerarquia >= 2,
      isThirdLevel: employee ? employee.IdReporta !== this.userInfo.IdEmpleado : this.userInfo.NivelJerarquia === 3,
    });
    let employeeId = employee ? employee.IdEmpleado : this.userInfo.IdEmpleado;
    this.getPendingShedule(employeeId);
    this.checkStatus(employeeId);
  }

  /**
   * Consulta la estructura del supervisor o tercer nivel
   */
  getStructure = () => {
    const configFilter = {
      tipoEstructura: true,
      estructuraDirecta: true
    };

    EmployeeService.getStructure({ page: 0, size: 0, filter: configFilter })
      .then((response) => {
        this.setState({ structure: response });
      })
      .catch(() => { });
  }

  checkStatus = (employeeId) => {
    ScheduleService.getStatus(employeeId)
      .then((response) => {
        this.setState({
          status: response.IdEstatus,
          statusName: response.Estatus
        });
      })
      .catch((error) => {
        ResponseHandlerService.error(error);
      });
  }

  onApprove = () => {
    this.setState({ showCommentDialog: { action: 'approve', open: true } });
  }

  onReject = () => {
    this.setState({ showCommentDialog: { action: 'reject', open: true } });
  }

  closeDialog = (dialog) => {
    if (dialog === 'comment') {
      this.setState({ showCommentDialog: { action: '', open: false } });
    }
  }

  approveConfirmation = ({ comment }, resetForm) => {
    const { employeeId, employeeFilter } = this.state;

    let request = {
      IdEmpleado: employeeFilter.id,
      IdEstatus: 3,
      Comentario: { Comentario: comment }
    };

    // Notificación - Tu supervisor ha aprobado tu horario
    let notificationToSend = {
      IdAmbiente: Environment.getCurrent().environmentId,
      URL: '#/configuraperfil',
      IdTipoNotificacion: 126,
      IdEmpleado: employeeFilter.id,
      Parametros: JSON.stringify({ Tab: 4 })
    };

    ScheduleService.putStatus(request)
      .then((response) => {
        if (employeeId !== notificationToSend.IdEmpleado) {
          NotificationsService.post(notificationToSend);
        }
        this.checkStatus(employeeFilter.id);
        this.closeDialog('comment');
        resetForm();
        ResponseHandlerService.success(response);
      })
      .catch((error) => {
        ResponseHandlerService.error(error);
      });
  }

  rejectConfirmation = ({ comment }, resetForm) => {
    const { employeeId, employeeFilter } = this.state;

    let request = {
      IdEmpleado: employeeFilter.id,
      IdEstatus: 4,
      Comentario: { Comentario: comment }
    };

    // Notificación - Tu supervisor ha rechazado tu horario
    let notificationToSend = {
      IdAmbiente: Environment.getCurrent().environmentId,
      URL: '#/configuraperfil',
      IdTipoNotificacion: 127,
      IdEmpleado: employeeFilter.id,
      Parametros: JSON.stringify({ Tab: 4 })
    };

    ScheduleService.putStatus(request)
      .then((response) => {
        if (employeeId !== notificationToSend.IdEmpleado) {
          NotificationsService.post(notificationToSend);
        }
        this.checkStatus(employeeFilter.id);
        this.closeDialog('comment');
        resetForm();
        ResponseHandlerService.success(response);
      })
      .catch((error) => {
        ResponseHandlerService.error(error);
      });
  }

  render() {
    const {
      employeeFilter,
      selectedEmployeeFromFilter,
      gridConfig,
      isSupervisor,
      isThirdLevel,
      structure,
      status,
      mySchedule,
      statusName
    } = this.state;

    return (
      <>
        {/* Buscar colabordador (Supervisor/ThirdLevel) */}
        {(isSupervisor || isThirdLevel) && (
          <SearchWrapper>
            <MUI.Grid container alignItems="center">
              {/* Colaborador */}
              <MUI.Grid item md={3} sm={4} xs={12}>
                <MUI.Box padding="8px">
                  <MUI.Autocomplete
                    label={i18n.t('GenericMessages.employee')}
                    searchList={structure}
                    searchBy="Nombre"
                    value={selectedEmployeeFromFilter}
                    onChange={(newValue) => {
                      this.filterShedule(newValue);
                      this.setState({ selectedEmployeeFromFilter: newValue });
                    }}
                  />
                </MUI.Box>
              </MUI.Grid>
              {/* Información del colaborador & Estatus */}
              <MUI.Grid item md={9} sm={6} xs={12}>
                <div style={{ display: 'flex' }}>
                  <BoxSeeingOf>
                    <BoxIcon>
                      <Icons.Info />
                    </BoxIcon>
                    {employeeFilter.id === this.userInfo.IdEmpleado ? (
                      <Typography.H6>{`${i18n.t('Shedule.lookingYouShedule')}.`}</Typography.H6>
                    ) : (
                      <>
                        <Typography.H6>{`${i18n.t('Shedule.lookingAtShedule')}:`}</Typography.H6>
                        <EmployeeCard>
                          <EmployeeDetail
                            avatar={employeeFilter.photo}
                            avatarSize="xs"
                            employeeName={employeeFilter.name}
                            employeeDetail={employeeFilter.job}
                          />
                        </EmployeeCard>
                      </>
                    )}
                  </BoxSeeingOf>
                  {/* Estatus */}
                  <BoxStatus>
                    <Typography.Text>
                      {`${i18n.t('GenericMessages.status')}: `}
                      <Typography.Strong>{statusName}</Typography.Strong>
                    </Typography.Text>
                  </BoxStatus>
                </div>
              </MUI.Grid>
            </MUI.Grid>
          </SearchWrapper>
        )}

        <LoadingWrapper area="loading-tab-pending-schedule">
          <ContentWrapper>
            <MUI.Box padding="8px">
              <DataGrid
                ref={this.dataGridRef}
                columns={gridConfig.columns}
                rows={gridConfig.rows}
                canAdd={gridConfig.canAdd}
                canEdit={gridConfig.canEdit}
                canDelete={gridConfig.canDelete}
                canSelect={gridConfig.canSelect}
                canSelectMultiple={false}
                canSort={true}
                isPaginated={false}
              />
            </MUI.Box>

            <br />

            <Validate
              status={status}
              isSupervisor={isSupervisor}
              myShedule={mySchedule}
              onApprove={this.onApprove}
              onReject={this.onReject}
            />
          </ContentWrapper>
        </LoadingWrapper>

        {/* Modal para aprobar o rechazar horario */}
        {this.state.showCommentDialog.open ? (
          <CommentDialog
            action={this.state.showCommentDialog.action}
            open={this.state.showCommentDialog.open}
            onClose={() => this.closeDialog('comment')}
            onRejectConfirmation={this.rejectConfirmation}
            onApproveConfirmation={this.approveConfirmation}
          />
        ) : null}
      </>
    );
  }
}

PendingSchedule.propTypes = {
  // Parámetros de la URL.
  queryParams: PropTypes.object,
  // Función para cambiar al Tab de pendientes.
  onChangeTab: PropTypes.func
};

// *************************************
// STYLED COMPONENTS
// *************************************
const SearchWrapper = styled.section`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 24px;
  padding: 8px;
  border: 1px solid ${(props) => props.theme.colors.greyLight};
  border-radius: 6px;
  box-shadow: ${(props) => props.theme.shadows.depth1};
`;

const ContentWrapper = styled.section`
  display: flex;
  flex-direction: column;
  padding: 8px;
  //border: 1px solid ${(props) => props.theme.colors.greyLight};
  //border-radius: 6px;
  //box-shadow: ${(props) => props.theme.shadows.depth1};
`;

const BoxSeeingOf = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  padding: 8px;
`;

const EmployeeCard = styled.div`
  display: flex;
  align-items: center;
  padding: 0px 16px;
`;

const BoxStatus = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 8px;
`;

const BoxIcon = styled.div`
  display: flex;
  margin-right: 16px;

  .MuiSvgIcon-root {
    font-size: 20px;
  }
`;

export default PendingSchedule;